import Keycloak from 'keycloak-js'
import keycloakConfig from '../config/keycloak.json'

export const keycloak: Keycloak.KeycloakInstance = new (Keycloak as any)({
  url: keycloakConfig['auth-server-url'],
  realm: keycloakConfig.realm,
  clientId: keycloakConfig.resource,
})
